module.exports = __webpack_public_path__ + "img/hand_shape.aa071397.svg";